import { Contract } from '../contexts/RentalContext'

export const getContractTemplate = (
  contract: Contract | any,
  agentName: string = 'Agent',
) => {
  const today = new Date(contract.createdAt || new Date()).toLocaleDateString(
    'ro-RO',
    {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    },
  )

  // Helper to safely get client details whether it's from Contract type or FormData
  const clientName =
    contract.clientName ||
    (contract.clientType === 'PF' ? contract.fullName : contract.companyName)
  const clientAddress =
    contract.clientAddress ||
    (contract.clientType === 'PF' ? contract.address : contract.companySediu)
  const clientIdentifier =
    contract.clientType === 'PF'
      ? `identificat cu CI seria ${contract.clientCI || contract.idSeries + ' ' + contract.idNumber}, CNP ${contract.clientCNP || contract.cnp}`
      : `CUI ${contract.clientCUI || contract.cui}, Nr. Reg. Com. ${contract.clientRegCom || contract.regCom}, reprezentată de ${contract.clientLegalRep || contract.legalRep}`

  const clientPhone =
    contract.clientPhone ||
    (contract.clientType === 'PF' ? contract.phone : contract.companyPhone)
  const clientEmail =
    contract.clientEmail ||
    (contract.clientType === 'PF' ? contract.email : contract.companyEmail)

  // PROPRIETAR CONTRACT
  if (contract.type === 'landlord' || contract.clientRole === 'proprietar') {
    return `CONTRACT DE INTERMEDIERE IMOBILIARĂ - PROPRIETAR

Nr. ${contract.id || '..........'} / Data: ${today}

ÎNTRE:

1. FREIM ESTATE SRL, cu sediul social în București, Str. Mareșal Alexandru Averescu, nr. 15b-15c, Etaj 4, Sector 1, înregistrată la Registrul Comerțului sub nr. J40/4535/14.04.2020, având CUI 42451855, reprezentată în vederea semnării și executării prezentului contract de către ${agentName}, în calitate de INTERMEDIAR, pe de-o parte;

ȘI

2. ${clientName}, ${contract.clientType === 'PF' ? 'domiciliat în' : 'cu sediul în'} ${clientAddress}, ${clientIdentifier}, telefon ${clientPhone}, e-mail ${clientEmail}, în calitate de PROPRIETAR, pe de altă parte.

ART. 1 - OBIECTUL CONTRACTULUI

1.1. Obiectul prezentului contract îl constituie prestarea de către INTERMEDIAR a serviciilor de intermediere imobiliară pentru facilitarea închirierii imobilului proprietate a PROPRIETARULUI, situat la adresa: ${contract.propertyAddress}.

1.2. Tipul imobil: ${contract.propertyType}
${contract.rentalPrice ? `1.3. Preț chirie solicitat: ${contract.rentalPrice} EUR/lună` : ''}
${contract.guarantee ? `1.4. Garanție: ${contract.guarantee} EUR` : ''}

ART. 2 - DURATA CONTRACTULUI

2.1. Prezentul contract se încheie pe o perioadă de 6 luni de la data semnării.

2.2. Contractul încetează de drept la semnarea contractului de închiriere între PROPRIETAR și CHIRIAȘ identificat de INTERMEDIAR.

ART. 3 - OBLIGAȚIILE PĂRȚILOR

3.1. Obligațiile INTERMEDIARULUI:
• Să identifice și să prezinte PROPRIETARULUI potențiali chiriași;
• Să faciliteze vizionarea imobilului;
• Să asiste PROPRIETARUL în negocierea și semnarea contractului de închiriere;
• Să verifice bonitatea chiriașilor potențiali.

3.2. Obligațiile PROPRIETARULUI:
• Să furnizeze toate informațiile necesare despre imobil;
• Să permită accesul la vizionări în condiții rezonabile;
• Să achite comisionul convenit conform art. 4;
• Să nu contacteze direct chiriașii identificați de INTERMEDIAR fără acordul acestuia.

ART. 4 - COMISIONUL

4.1. Comisionul datorat de către PROPRIETAR către INTERMEDIAR este de ${contract.commissionPercent}% din valoarea primei luni de chirie ${contract.vatIncluded || contract.vatOption === 'vat_included' ? '(TVA inclus)' : '+ TVA (21%)'}.

4.2. Comisionul devine exigibil la momentul semnării contractului de închiriere între PROPRIETAR și CHIRIAȘ identificat de INTERMEDIAR.

4.3. Plata comisionului se va efectua în termen de 5 zile lucrătoare de la semnarea contractului de închiriere.

ART. 5 - CLAUZE SPECIALE

5.1. Orice tranzacție realizată prin informațiile și intervenția INTERMEDIARULUI atrage obligația de plată a comisionului.

5.2. Dacă PROPRIETARUL închiriază imobilul direct sau printr-un terț, pe baza informațiilor primite de la INTERMEDIAR, va datora comisionul stabilit.

ART. 6 - ÎNCETAREA CONTRACTULUI

6.1. Prezentul contract încetează prin:
• Semnarea contractului de închiriere între PROPRIETAR și CHIRIAȘ;
• Expirarea termenului de 6 luni;
• Acordul părților;
• Rezilierea unilaterală pentru neexecutarea obligațiilor contractuale.

ART. 7 - LITIGII

7.1. Litigiile născute din interpretarea sau executarea prezentului contract vor fi soluționate pe cale amiabilă, iar în caz contrar, de instanțele competente din București.

ART. 8 - DISPOZIȚII FINALE

8.1. Orice modificare a prezentului contract se face doar prin act adițional semnat de ambele părți.

8.2. Contractul a fost încheiat în două exemplare originale, câte unul pentru fiecare parte.

ART. 9 - PROTECȚIA DATELOR CU CHARACTER PERSONAL

9.1. Părțile declară că au luat cunoștință de prevederile Regulamentului (UE) 2016/679 privind protecția persoanelor fizice în ceea ce privește prelucrarea datelor cu caracter personal (GDPR).

9.2. INTERMEDIARUL, în calitate de operator de date, va prelucra datele personale ale PROPRIETARULUI strict în scopul executării prezentului contract.


SEMNĂTURI:

INTERMEDIAR:                                    PROPRIETAR:
FREIM ESTATE SRL                                ${clientName}
Reprezentat de: ${agentName}

Semnătură: _________________                    Semnătură: _________________

Data: ${today}`
  } else {
    // CHIRIAȘ CONTRACT
    return `CONTRACT DE INTERMEDIERE ÎN VEDEREA ÎNCHIRIERII - CHIRIAȘ

ÎNCHEIAT ASTĂZI, ${today}

ÎNTRE:

1. FREIM ESTATE SRL, cu sediul social în București, Str. Mareșal Alexandru Averescu, nr. 15b-15c, Etaj 4, Sector 1, înregistrată la Registrul Comerțului sub nr. J40/4535/14.04.2020, având CUI 42451855, reprezentată în vederea semnării și executării prezentului contract de către ${agentName}, în calitate de INTERMEDIAR, pe de-o parte;

ȘI

2. ${clientName}, ${contract.clientType === 'PF' ? 'domiciliat în' : 'cu sediul în'} ${clientAddress}, ${clientIdentifier}, telefon ${clientPhone}, e-mail ${clientEmail}, denumit în continuare CHIRIAȘ, pe de altă parte.

ART. 1 - OBIECTUL CONTRACTULUI

1.1. Obiectul prezentului contract îl constituie prestarea de către INTERMEDIAR a serviciilor de intermediere imobiliară pentru facilitarea vizionării și eventual închirierii unui imobil identificat de INTERMEDIAR, care corespunde cerințelor exprimate de CHIRIAȘ.

1.2. Imobilul identificat este situat la adresa: ${contract.propertyAddress}

1.3. Tipul imobil: ${contract.propertyType}
${contract.rentalPrice ? `1.4. Preț chirie: ${contract.rentalPrice} EUR/lună` : ''}

ART. 2 - DURATA CONTRACTULUI

2.1. Prezentul contract se încheie pe o perioadă de 6 luni de la data semnării.

2.2. Contractul încetează de drept la semnarea contractului de închiriere între CHIRIAȘ și PROPRIETAR pentru imobilul vizionat.

ART. 3 - OBLIGAȚIILE PĂRȚILOR

3.1. Obligațiile INTERMEDIARULUI:
• Să faciliteze accesul CHIRIAȘULUI la vizionarea imobilului identificat;
• Să asiste CHIRIAȘUL în negocierea și semnarea contractului de închiriere;
• Să verifice conformitatea imobilului cu cerințele CHIRIAȘULUI.

3.2. Obligațiile CHIRIAȘULUI:
• Să participe la vizionarea imobilului;
• Să achite comisionul convenit conform art. 4;
• Să nu contacteze direct PROPRIETARUL fără acordul și implicarea INTERMEDIARULUI.

ART. 4 - COMISIONUL

4.1. Comisionul datorat de către CHIRIAȘ către INTERMEDIAR este de ${contract.commissionPercent}% din valoarea primei luni de chirie ${contract.vatIncluded || contract.vatOption === 'vat_included' ? '(TVA inclus)' : '+ TVA (21%)'}.

4.2. Comisionul devine exigibil doar la momentul semnării contractului de închiriere între CHIRIAȘ și PROPRIETAR.

4.3. Plata comisionului se va efectua în termen de 5 zile lucrătoare de la semnarea contractului de închiriere.

ART. 5 - CLAUZE SPECIALE

5.1. Orice tranzacție realizată prin informațiile și intervenția INTERMEDIARULUI atrage obligația de plată a comisionului.

5.2. Dacă CHIRIAȘUL închiriază imobilul direct sau printr-un terț, pe baza informațiilor primite de la INTERMEDIAR, va datora comisionul stabilit.

ART. 6 - ÎNCETAREA CONTRACTULUI

6.1. Prezentul contract încetează prin:
• Semnarea contractului de închiriere între CHIRIAȘ și PROPRIETAR;
• Expirarea termenului de 6 luni;
• Acordul părților;
• Rezilierea unilaterală pentru neexecutarea obligațiilor contractuale.

ART. 7 - LITIGII

7.1. Litigiile născute din interpretarea sau executarea prezentului contract vor fi soluționate pe cale amiabilă, iar în caz contrar, de instanțele competente din București.

ART. 8 - DISPOZIȚII FINALE

8.1. Orice modificare a prezentului contract se face doar prin act adițional semnat de ambele părți.

8.2. Contractul a fost încheiat în două exemplare originale, câte unul pentru fiecare parte.

ART. 9 - PROTECȚIA DATELOR CU CHARACTER PERSONAL

9.1. Părțile declară că au luat cunoștință de prevederile Regulamentului (UE) 2016/679 privind protecția persoanelor fizice în ceea ce privește prelucrarea datelor cu caracter personal (GDPR).


SEMNĂTURI:

INTERMEDIAR:                                    CHIRIAȘ:
FREIM ESTATE SRL                                ${clientName}
Reprezentat de: ${agentName}

Semnătură: _________________                    Semnătură: _________________

Data: ${today}`
  }
}
